<template>
  <div class="social">
    <a v-for="(item, index) in data" :key="index" :href="item.link" target="_blank">
      <v-icon :name="item.icon" />
    </a>
  </div>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style lang="scss">
.social a {
  color: #ffffff;
  width: 40px;
  height: 40px;
  border: 1px solid #ffffff;
  text-align: center;

  display: inline-block;
  border-radius: 100%;
  margin-right: 10px;
  line-height: 38px;
  transition: 0.3s linear;

  svg {
    height: 15px;
    width: auto;
  }

  &:last-child {
    margin: 0;
  }

  &:hover {
    background: #ffffff;
    color: $main-color;
  }
}
</style>